module.exports = __webpack_public_path__ + "img/home.349e6d26.svg";